export const getGeoLocation = state => state.session.geoLocation;



// WEBPACK FOOTER //
// ./src/client/js/store/selectors/geoLocation/index.js